let seed = 0

export default function generateId() {
  return (seed += 1)
}
